export default theme => ({

  root: {
    width: theme.qborder.drawer.width,
    marginTop: theme.spacing.unit * 7,
    paddingTop: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2
  },

  form: {
    display: 'flex',
    'flex-direction': 'column'
  }

});





// WEBPACK FOOTER //
// ./src/styles/components/SettingsDrawer.js